var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateDependence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8400E6;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,4.93h0L12.32,2.05a1,1,0,0,0-.61,0l-9,2.75A1,1,0,0,0,2,5.57,1.06,1.06,0,0,0,1.93,6V9A1.07,1.07,0,0,0,3,10.07H5V17H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H19V10.07h2A1.07,1.07,0,0,0,22.07,9V6A1.07,1.07,0,0,0,21,4.93ZM12,4l2.64.88H9.1Zm-5,6H8V17H7ZM13,17V10.07h1V17Zm-2,0H10V10.07h1Zm9,3H4V19H20Zm-3-3H16V10.07h1Zm2.93-9.07H4.07V7.07H19.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateDependence);
export default __webpack_public_path__ + "static/media/State_dependence.303e81fd785789f69602a8c9088b120a.svg";
export { ForwardRef as ReactComponent };